/* eslint-disable import/prefer-default-export */
export function getStudentImage(student) {
  if (typeof student.student_image === 'string') {
    return student.student_image;
  }

  if (student.student_image.image_size_190x190) {
    return student.student_image.image_size_190x190;
  }

  return student.student_image.thumbnail;
}
